/* global gtag */
import React, { useEffect, useRef, useState } from "react";
import {
  setRecomandModal,
  setSelectedAd,
  setTooltipOpen,
} from "../../../redux/slices/LcaSlice";
import { Button, Spinner } from "reactstrap";
import {
  FaCalendarAlt,
  FaChevronDown,
  FaChevronUp,
  FaCommentAlt,
  FaEnvelopeOpenText,
  FaGlobe,
  FaPhoneAlt,
  FaQuestionCircle,
  FaUser,
  FaUserAlt,
} from "react-icons/fa";
import { MdGroups, MdPhone, MdSkipNext, MdSkipPrevious } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import "./LcaCards.css";
import "moment-timezone/builds/moment-timezone-with-data";
import { UncontrolledTooltip } from "reactstrap";
import { BsInfoCircleFill } from "react-icons/bs";
import {
  checkExisting,
  handleActionClick,
  setActionType,
  setIsChatModalOpen,
  setSampleAd,
  setShowCallDialog,
  setInquiryNeedOpen,
} from "../../../redux/slices/SearchBarSlice";
import { toast } from "react-toastify";
import { initiateCall } from "../Data";
import CustomButton from "../../CustomButton";

const LcaActionButtons = ({
  ad,
  handleIndiviualCall,
  toggleEvents,
  toggleQuestions,
  openOfferModal,
  handleSkip,
  buttonRef,
  tooltipRef,
  timeLeft,
  questionsVisible,
  eventsVisible,
}) => {
  const isProd = process.env.REACT_APP_PRODUCTION === "true";
  const dispatch = useDispatch();
  const islogin = useSelector((state) => state.user.isLogin);
  const userdata = useSelector((state) => state.user);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const { sampleAd, generatedNeedId } = useSelector((state) => state.searchBar);
  const { gottonData, tooltipOpen, recomandModal } = useSelector(
    (state) => state.lcAds
  );
  const [checkExistingNeed, setCheckExistingNeed] = useState(false);
  const isAdmin = user && user.Role === "admin";
  const isVendor = user?.Role === "provider";
  const [phoneButton, setPhoneButton] = useState("Show Phone Number");

  useEffect(() => {
    if (ad.Id === generatedNeedId) {
      // setPhoneButton(`${ad?.Phone || 0}`);
      setPhoneButton(`${ad?.Phone || 0} Ext# ${ad.dialExtension || 0}`);
    }
  }, [generatedNeedId, sampleAd]);

  const isAdInMyOffers = (ad) => {
    const offers = ad?.approveProviderId;
    const parseIds = offers?.split(",").map(Number);
    return parseIds?.includes(user?.UserID);
  };

  const isAlreadyGotton = (ad) => {
    const offers = ad?.approveProviderId;
    const parseIds = offers?.split(",").map(Number);
    return parseIds?.length >= 5;
  };

  const handleRecomend = (event, ad) => {
    event.stopPropagation();
    dispatch(setSelectedAd(ad));
    dispatch(setRecomandModal(true));
  };

  const [countdownFinished, setCountdownFinished] = useState(false);
  const showMessageButton = islogin;
  useEffect(() => {
    setCountdownFinished(false);

    const timer = setTimeout(() => {
      setCountdownFinished(true);
    }, 295 * 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleAction = async (event, action) => {
    event.stopPropagation();
    if (!countdownFinished) {
      dispatch(setSampleAd(ad));
      dispatch(setActionType(action));
      setPhoneButton(`${ad?.Phone || 0}`);

      if (action === "CALL") {
        dispatch(setShowCallDialog(true));
      } else if (action === "TEXT") {
        dispatch(setIsChatModalOpen(true));
      } else if (action === "VISIT") {
        window.open(ad?.websiteLink, "_blank");
      }
      return;
    }
    dispatch(setSampleAd(ad));
    dispatch(setActionType(action));
    if (isProd && window.dataLayer) {
      if (action === "CALL") {
        window.dataLayer.push({
          event: "phone_call_clicked",
          method: "phone_button_click",
          ad_id: ad?.id || ad?.Id,
        });
      } else if (action === "TEXT") {
        window.dataLayer.push({
          event: "send_message_clicked",
          method: "send_message_button_click",
          ad_id: ad?.id || ad?.Id,
        });
      }
    }
    // If user is admin or vendor, handle action directly
    if (isAdmin || isVendor) {
      setPhoneButton(`${ad?.Phone || 0} Ext# ${ad.dialExtension || 0}`);
      // setPhoneButton(`${ad?.Phone || 0}`);
      if (action === "CALL") {
        dispatch(setShowCallDialog(true));
      } else if (action === "TEXT") {
        dispatch(setIsChatModalOpen(true));
      } else if (action === "VISIT") {
        window.open(ad.websiteLink, "_blank");
      }
      return;
    }

    // For non-admin/non-vendor users, check if the need exists
    let needExists = false;
    setCheckExistingNeed(true);
    if (islogin) {
      const constructedTitle = ad?.Title + " (Auto Generated)";
      const checkForm = {
        Title: constructedTitle,
        userId: user.UserID,
      };
      const result = await dispatch(checkExisting(checkForm)).unwrap();
      needExists = result.data;
    }

    // If need exists, handle the action
    if (needExists) {
      setPhoneButton(`${ad?.Phone || 0} Ext# ${ad.dialExtension || 0}`);
      // setPhoneButton(`${ad?.Phone || 0}`);
      if (action === "CALL") {
        dispatch(setShowCallDialog(true));
      } else if (action === "TEXT") {
        dispatch(setIsChatModalOpen(true));
      } else if (action === "VISIT") {
        window.open(ad.websiteLink, "_blank");
      }
      setCheckExistingNeed(false);
      return;
    }
    if (islogin) {
      const actionForm = {
        userId: user.UserID,
        postId: ad.Id,
        postType: 1,
        clickType: action === "CALL" ? 1 : action === "TEXT" ? 2 : 3,
        createdBy: user.UserID,
      };
      dispatch(handleActionClick(actionForm));
    }
    setCheckExistingNeed(false);
    dispatch(setInquiryNeedOpen(true));
  };

  const handleGroupCall = async (ad) => {
    const ID = ad?.Id;
    const phoneDetailsObj = [
      {
        email: ad?.Email,
        phoneNumber: ad?.Phone,
        countryCode: ad?.countryCode,
      },
      {
        email: "",
        phoneNumber:
          ad?.alternativePhoneOne === null || ad?.alternativePhoneOne === ""
            ? ""
            : ad?.alternativePhoneOne,
        countryCode:
          ad?.alternativePhoneOne === null || ad?.alternativePhoneOne === ""
            ? ""
            : ad?.countryCode,
      },
      {
        email: "",
        phoneNumber:
          ad?.alternativePhoneTwo === null || ad?.alternativePhoneTwo === ""
            ? ""
            : ad?.alternativePhoneTwo,
        countryCode:
          ad?.alternativePhoneTwo === null || ad?.alternativePhoneTwo === ""
            ? ""
            : ad?.countryCode,
      },
      {
        email: user?.Email,
        phoneNumber: user?.Phone,
        countryCode: user?.CountryCode,
      },
    ];
    const phoneDetails = JSON.stringify(phoneDetailsObj);
    let formData = {
      phoneDetails: phoneDetails,
      email: user?.Email,
      userTo: ad?.createdBy,
      userFrom: user?.UserID,
      callType: 1, //1 for phone,2 for voip,3 for zoom
      userToPhone: phoneDetails,
      userFromPhone: `${user?.CountryCode}${user?.Phone}`,
      typeId: ad?.Id,
      Type: "need",
    };
    toast.success("Group Call send to your Mobile please respond");
    await initiateCall(formData);
  };
  return (
    <>
      {ad.engagedCouple == 1 && (
        <div className="w-100 text-center engagedCouple">
          {user?.UserID != ad.createdBy && (
            <>
              {isAdInMyOffers(ad) ? (
                <div className="d-flex flex-row flex-md-column gap-2">
                  {" "}
                  {/* Main change here */}
                  {/* Call Button with Dropdown */}
                  <div className="dropdown-center position-relative flex-fill">
                    <CustomButton
                      onClick={(event) => handleAction(event, "TEXT")}
                      type="default"
                      icon={FaPhoneAlt}
                      title="Call Me"
                      className="w-100"
                      disabled={checkExistingNeed}
                    >
                      {checkExistingNeed ? (
                        <Spinner className="me-2" />
                      ) : (
                        "Call Me"
                      )}
                    </CustomButton>
                    {/* Dropdown Menu */}
                    <ul
                      className="dropdown-menu dropdown-menu-center"
                      style={{ cursor: "pointer" }}
                    >
                      <li>
                        <a
                          className="dropdown-item text-center fw-bold"
                          onClick={() => handleIndiviualCall(ad)}
                        >
                          Individual Call <FaUser />
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item text-center fw-bold"
                          onClick={() => handleGroupCall(ad)}
                        >
                          Group Call <MdGroups size={20} />
                        </a>
                      </li>
                    </ul>
                  </div>
                  {/* Message Button */}
                  <CustomButton
                    type="default"
                    icon={FaEnvelopeOpenText}
                    title="Send Message"
                    className="w-100 flex-fill mb-2"
                    onClick={(event) => handleAction(event, "TEXT")}
                    disabled={checkExistingNeed}
                  >
                    {checkExistingNeed ? (
                      <Spinner className="me-2" />
                    ) : (
                      "Message Me"
                    )}
                  </CustomButton>
                </div>
              ) : isAlreadyGotton(ad) ? (
                <CustomButton
                  type="delete"
                  icon={FaUserAlt}
                  title="Other venues took customer"
                  className="w-100 mb-2"
                  disabled
                >
                  Other venues took customer
                </CustomButton>
              ) : +gottonData?.totalMessages >=
                +gottonData?.getCustomerLimit ? (
                <CustomButton
                  type="delete"
                  icon={FaCalendarAlt}
                  title="Monthly Limit Exceeded"
                  className="w-100 mb-2"
                  disabled
                >
                  Monthly Limit Exceeded
                </CustomButton>
              ) : (
                <>
                  <CustomButton
                    type="default"
                    className="w-100 mb-2"
                    disabled={checkExistingNeed}
                    onClick={(event) => openOfferModal(event, ad)}
                    icon={FaUserAlt}
                    title="Get Customer!"
                  >
                    {checkExistingNeed ? (
                      <Spinner className="me-2" />
                    ) : (
                      <>
                        {" "}
                        Get Customer!
                        <br />
                        {islogin && (
                          <>
                            {timeLeft === "00:00:00" ? (
                              <p
                                className=" m-0 text-nowrap"
                                style={{ fontSize: "12px" }}
                              >
                                Late Fee $10
                              </p>
                            ) : (
                              <div className="d-flex align-items-center justify-content-center">
                                <p
                                  className="m-0"
                                  style={{
                                    fontSize: "small",
                                    // color: "var(--white)",
                                    textWrap: "nowrap",
                                  }}
                                >
                                  {timeLeft === "00:00:00"
                                    ? `Time's Up: ${timeLeft}`
                                    : `Time left: ${timeLeft}`}
                                </p>
                                <button
                                  id="ScheduleUpdateTooltip"
                                  ref={buttonRef}
                                  className="ms-2 position-relative"
                                  style={{
                                    backgroundColor: "inherit",
                                    // color: "var(--white)",
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setTimeout(() => {
                                      dispatch(setTooltipOpen(true));
                                    }, 0);
                                  }}
                                >
                                  <BsInfoCircleFill size={17} />
                                </button>
                                <UncontrolledTooltip
                                  placement="top"
                                  target="ScheduleUpdateTooltip"
                                  trigger="click"
                                  isOpen={tooltipOpen}
                                  toggle={() => dispatch(setTooltipOpen(false))}
                                  container="body"
                                  innerRef={tooltipRef}
                                >
                                  Free during 24-hour timer, $10 late fee
                                  applies after
                                </UncontrolledTooltip>
                              </div>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </CustomButton>
                  {(isVendor || isAdmin) && (
                    <CustomButton
                      type={ad?.needSkipCustomer == 1 ? "delete" : "active"}
                      className="w-100 mb-2"
                      disabled={checkExistingNeed}
                      onClick={(event) => handleSkip(event, ad)}
                      icon={
                        ad?.needSkipCustomer == 1 ? MdSkipNext : MdSkipPrevious
                      }
                      title={ad?.needSkipCustomer == 1 ? "Unskip" : "Skip"}
                    >
                      {checkExistingNeed ? (
                        <Spinner className="me-2" />
                      ) : (
                        <>{ad?.needSkipCustomer == 1 ? "Unskip" : "Skip"}</>
                      )}
                    </CustomButton>
                  )}
                </>
              )}
            </>
          )}
          <CustomButton
            type="default"
            className="w-100 mb-2"
            onClick={(event) => toggleQuestions(event, ad)}
            icon={questionsVisible[ad.Id] ? FaChevronUp : FaChevronDown}
            disabled={checkExistingNeed}
            title={questionsVisible[ad.Id] ? "Hide Q&A" : "Show Q&A"}
          >
            {checkExistingNeed ? (
              <Spinner className="me-2" />
            ) : (
              <> {questionsVisible[ad.Id] ? "Hide Q&A" : "Show Q&A"}</>
            )}
          </CustomButton>
          <CustomButton
            type="default"
            className="w-100 mb-2"
            onClick={(event) => toggleEvents(event, ad)}
            icon={eventsVisible[ad.Id] ? FaChevronUp : FaChevronDown}
            disabled={checkExistingNeed}
            title={eventsVisible[ad.Id] ? "Hide Event" : "Show Event"}
          >
            {checkExistingNeed ? (
              <Spinner className="me-2" />
            ) : (
              <> {eventsVisible[ad.Id] ? "Hide Event" : "Show Event"}</>
            )}
          </CustomButton>
          {isAdmin && (
            <CustomButton
              type="default"
              className="w-100 mb-2"
              onClick={(event) => handleRecomend(event, ad)}
              icon={FaUserAlt}
              disabled={checkExistingNeed}
              title="Recomend"
            >
              {checkExistingNeed ? <Spinner className="me-2" /> : "Recomend"}
            </CustomButton>
          )}
        </div>
      )}
      {ad.engagedCouple != 1 &&
      user?.UserID != ad.createdBy &&
      ad?.checkedValue === "mobile" ? (
        <div className="w-100 text-center need">
          <CustomButton
            className="w-100 mb-2"
            onClick={(event) => handleAction(event, "CALL")}
            disabled={checkExistingNeed}
            icon={MdPhone}
            type="default"
            title={phoneButton}
          >
            {/* {checkExistingNeed ? (
              <Spinner className="me-2" />
            ) : (
              <>{phoneButton}</>
            )} */}
            {phoneButton}
          </CustomButton>
          {showMessageButton && (
            <CustomButton
              className="w-100 mb-2"
              disabled={checkExistingNeed}
              onClick={(event) => handleAction(event, "TEXT")}
              icon={FaCommentAlt}
              type="default"
              title="Send Message"
            >
              {/* {checkExistingNeed ? <Spinner className="me-2" /> : "Send Message"} */}
              Send Message
            </CustomButton>
          )}
          {isAdmin && ad.engagedCouple == 1 && (
            <CustomButton
              className="w-100 mb-2"
              onClick={(event) => handleRecomend(event, ad)}
              disabled={checkExistingNeed}
              icon={FaUserAlt}
              type="default"
              title="Recomend"
            >
              {/* {checkExistingNeed ? <Spinner className="me-2" /> : "Recomend"} */}
              Recomend
            </CustomButton>
          )}
        </div>
      ) : (
        ad.engagedCouple != 1 &&
        ad?.checkedValue === "website" &&
        user?.UserID != ad.createdBy && (
          <CustomButton
            className="w-100 mb-2"
            onClick={(event) => handleAction(event, "VISIT")}
            disabled={checkExistingNeed}
            icon={FaGlobe}
            title="Visit Webpage"
            type="default"
          >
            {checkExistingNeed ? (
              <Spinner className="me-2" />
            ) : (
              <>Visit Webpage</>
            )}
          </CustomButton>
        )
      )}
    </>
  );
};

export default LcaActionButtons;
